import { StoreModel } from '../store.model';
import { AuthenticationState, IAccountInfo } from 'react-aad-msal';

export const isAuthenticatedSelector = (store: StoreModel) : boolean => store.authenticationState.initialized && store.authenticationState.state === AuthenticationState.Authenticated;

export const isAuthenticationInitialized = (store: StoreModel) : boolean => store.authenticationState.initialized;

export const aadAccountSelector = (store: StoreModel) : IAccountInfo | undefined => store.authenticationState.account;